"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseSimpleT = exports.noneT = exports.optionalT = exports.tupleT = exports.listT = exports.principalT = exports.bufferT = exports.booleanT = exports.stringAsciiT = exports.stringT = exports.numberT = exports.transcoders = void 0;
const transactions_1 = require("@stacks/transactions");
const decoders_1 = require("./decoders");
const encoders_1 = require("./encoders");
const helpers_1 = require("../utils/helpers");
function transcoders(constructOptions) {
    return constructOptions;
}
exports.transcoders = transcoders;
exports.numberT = transcoders({
    encode: encoders_1.numberCV,
    decode: decoders_1.intResult,
});
exports.stringT = transcoders({
    encode: transactions_1.stringUtf8CV,
    decode: decoders_1.stringResult,
});
exports.stringAsciiT = transcoders({
    encode: transactions_1.stringAsciiCV,
    decode: decoders_1.stringResult,
});
exports.booleanT = transcoders({
    encode: encoders_1.booleanCV,
    decode: decoders_1.boolResult,
});
exports.bufferT = transcoders({
    encode: transactions_1.bufferCV,
    decode: decoders_1.bufferResult,
});
exports.principalT = transcoders({
    encode: encoders_1.principalCV,
    decode: decoders_1.principalResult,
});
const listT = (listItemTranscoder) => {
    return transcoders({
        encode: (0, encoders_1.listEncoder)(listItemTranscoder.encode),
        decode: (0, decoders_1.listDecoder)(listItemTranscoder.decode),
    });
};
exports.listT = listT;
const tupleT = (transcoderObj) => {
    const encode = (0, encoders_1.tupleEncoder)((0, helpers_1.mapValues)(transcoderObj, (o) => o.encode));
    const decode = (0, decoders_1.tupleDecoder)((0, helpers_1.mapValues)(transcoderObj, (o) => o.decode));
    return transcoders({ encode, decode });
};
exports.tupleT = tupleT;
const optionalT = (someTranscoder) => {
    return transcoders({
        encode: (0, encoders_1.optional)(someTranscoder.encode),
        decode: (0, decoders_1.optionalDecoder)(someTranscoder.decode),
    });
};
exports.optionalT = optionalT;
exports.noneT = transcoders({
    encode: transactions_1.noneCV,
    decode: decoders_1.noneResult,
});
const responseSimpleT = (okValueTransducer) => {
    return transcoders({
        encode: (0, encoders_1.responseSimpleEncoder)(okValueTransducer.encode),
        decode: (0, decoders_1.responseSimpleDecoder)(okValueTransducer.decode),
    });
};
exports.responseSimpleT = responseSimpleT;
